import { Empty, List, Spin, Typography } from 'antd';
import classNames from 'classnames';

import type { AiChatMessagesProps } from '@pages/AiAgents/types';

import type { FC } from 'react';

export const AiChatMessages: FC<AiChatMessagesProps> = ({
  messages,
  isMessagesLoading,
}) => {
  if (!isMessagesLoading && messages.length === 0) {
    return (
      <div className="ai-agents-chat__empty">
        <Empty description="Нет сообщений" />
      </div>
    );
  }

  return (
    <div className="ai-agents-chat__messages-list">
      {isMessagesLoading && (
        <div className="ai-agents-chat__messages-loading">
          <Spin size="small" />
        </div>
      )}

      <List
        dataSource={messages}
        renderItem={(message) => {
          const itemClassName = classNames('ai-agents-message', {
            'ai-agents-message--own': message.isOwn,
            'ai-agents-message--ai': !message.isOwn && !message.isSystem,
            'ai-agents-message--system': message.isSystem,
          });

          return (
            <List.Item className={itemClassName} key={message.id}>
              <div className="ai-agents-message__bubble">
                {!message.isSystem && (
                  <div className="ai-agents-message__sender">
                    <Typography.Text type="secondary">
                      {message.senderName}
                    </Typography.Text>
                  </div>
                )}

                {message.text && (
                  <div className="ai-agents-message__text">
                    <Typography.Text
                      type={message.isSystem ? 'secondary' : undefined}
                    >
                      {message.text}
                    </Typography.Text>
                  </div>
                )}

                <div className="ai-agents-message__meta">
                  <Typography.Text
                    type="secondary"
                    className="ai-agents-message__time"
                  >
                    {message.createdAtFormatted}
                  </Typography.Text>
                </div>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};
